<template>
    <transition name="fade" mode="out-in">
        <div :key="activity.timestamp">
            <span v-if="isMessage">
                {{ activity.author.display_name }} made a comment <relative-time :timestamp="activity.timestamp"/>
            </span>
            <span v-else v-html="activity.message"/>
        </div>
    </transition>
</template>

<script>
import RelativeTime from '../Global/RelativeTime'

export default {
    name: 'LastActivity',

    props: {
        activity: {
            required: true,
            type: Object
        }
    },

    computed: {
        isMessage () {
            return this.activity.type === 'message'
        }
    },

    components: {
        RelativeTime
    }
}
</script>
